// extracted by mini-css-extract-plugin
export default {"assessments-results-wrapper":"assessmentsResults_assessments-results-wrapper__HMmUd","assessment-section-gallery":"assessmentsResults_assessment-section-gallery__hdJ5M"};